import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import Icon1 from './icons/Icon1';
import Icon2 from './icons/Icon2';
import Icon3 from './icons/Icon3';
import Icon4 from './icons/Icon4';

const OnePicture: React.FC = () => {
    const { t } = useLang('one_picture');
    const item1 = (
        <div className="text-box">
            <div className="title">{t('1_title')}</div>
            <div className="desc">{t('1_desc')}</div>
        </div>
    );

    const item2 = (
        <div className="text-box">
            <div className="title">{t('2_title')}</div>
            <div className="desc">{t('2_desc')}</div>
        </div>
    );

    const item3 = (
        <div className="text-box">
            <div className="title">{t('3_title')}</div>
            <div className="desc">{t('3_desc')}</div>
        </div>
    );

    const item4 = <div className="title">{t('4_title')}</div>;

    const item5 = (
        <div className="text-box">
            <div className="title">{t('5_title')}</div>
            <div className="desc">{t('5_desc')}</div>
        </div>
    );

    const item6 = (
        <div className="text-box">
            <div className="title">{t('6_title')}</div>
            <div className="desc">{t('6_desc')}</div>
        </div>
    );

    const item7 = (
        <div className="text-box">
            <div className="title">{t('7_title')}</div>
            <div className="desc">{t('7_desc')}</div>
            <div className="icon-list">
                <Icon1 />
                <Icon2 />
                <Icon3 />
                <Icon4 />
            </div>
        </div>
    );

    const item8 = (
        <div className="text-box">
            <div className="title">{t('8_title')}</div>
            <div className="desc">{t('8_desc')}</div>
        </div>
    );

    return (
        // 311 + 504 + 287 + 11.24 * 2;
        <div className={styles.OnePicture}>
            <div className="pc">
                <div className="box-l">
                    <div className="box-l-t">
                        <div className="box-l-t-l">
                            <div className="box-l-t-l-t">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747375724904/DPU%E7%BB%99%E4%B8%AD%E5%A4%AE%E7%A9%BA%E8%B0%83%E4%BE%9B%E7%94%B5%20(1).png" />
                                {item1}
                            </div>
                            <div className="box-l-t-l-b">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747375827072/Frame%20161269270%20(3)%20(1).png" />
                                {item3}
                            </div>
                        </div>
                        <div className="box-l-t-r">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747375251937/DPU_15%20Battery_Product%201.jpg" />
                            {item2}
                        </div>
                    </div>
                    <div className="box-l-b">
                        <div className="box-l-b-l">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364827183/Frame%20161269274%20(1).png" />
                            {item6}
                        </div>
                        <div className="box-l-b-r">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364964422/ONEPLUS%20Ace2%202%20(1).jpg" />
                            {item7}
                        </div>
                    </div>
                </div>
                <div className="box-r">
                    <div className="box-t">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747375252613/Frame.jpg" />
                        {item4}
                    </div>
                    <div className="box-c">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747375252276/image%205154401.jpg" />
                        {item5}
                    </div>
                    <div className="box-b">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747375252912/DPU_UPS%201.jpg" />
                        {item8}
                    </div>
                </div>
            </div>

            <div className="h5">
                <div className="box-1">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364430153/1-h5.jpg" />
                    {item2}
                </div>
                <div className="box-2">
                    <div className="box-l">
                        <div className="box-l-t">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364430387/2-h5.jpg" />
                            {item1}
                        </div>
                        <div className="box-l-b">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364964422/ONEPLUS%20Ace2%202%20(1).jpg" />
                            {item7}
                        </div>
                    </div>
                    <div className="box-r">
                        <div className="box-l-t">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364430709/3-h5.jpg" />
                            {item5}
                        </div>
                        <div className="box-l-b">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747365057948/Frame.png" />
                            {item4}
                        </div>
                    </div>
                </div>

                <div className="box-3">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364827183/Frame%20161269274%20(1).png" />
                    {item6}
                </div>
                <div className="box-4">
                    <div className="box-l">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364763626/Frame%20161269421%20(1).png" />
                        {item3}
                    </div>
                    <div className="box-r">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1747364763852/Frame%20161269423%20(1).png" />
                        {item8}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnePicture;
